const styles = {
    selclass: ' mt-1 bg-light text-dark bottom-border-open-select',
    unselclass:  'bg-primary text-white mt-1 bottom-border-open',
    mysubnavbar:"bg-primary text-light mb-1",
    source_row:"border-bottom mb-1 p-1",
    subtitle:"font-weight-bold text-info me-1"

}

export default styles